import { HStack, Image, VStack, Text, Box } from '@chakra-ui/react';
import React, { ReactElement } from 'react';
import { RelevantYearName, AgeGroup, Tags } from '@novaheal/types';
import { FavoriteIcon, FavoriteSolidIcon, SuccessIcon, SuccessSolidIcon } from 'assets/icons/v2';
import { NovaIconButton } from 'components/ui/NovaIconButton';
import { ArticleTags } from './ArticleTags';
import InformationBar from './InformationBar';

type Props = {
  coverImageUrl: string;
  title: string;
  readingTime: number;
  relevantYears: RelevantYearName[];
  ageGroups: AgeGroup[];
  tags: Tags;
  handleLikeChange: () => void;
  handleReadChange: () => void;
  isLiked?: boolean | null;
  isRead?: boolean | null;
};

export const ArticleHeroDesktop = ({
  coverImageUrl,
  title,
  readingTime,
  relevantYears,
  ageGroups,
  tags,
  isLiked = false,
  handleLikeChange,
  handleReadChange,
  isRead,
}: Props): ReactElement => {
  return (
    <Box width="100%" padding="40px" bg="background.primary" borderRadius="15px 15px 0 0">
      <HStack gap="35px" position="relative" overflow="hidden">
        <Image src={coverImageUrl} height="200px" width="200px" objectFit="cover" />
        <HStack position="absolute" top="0" right="0">
          <NovaIconButton
            variant="primary"
            icon={isRead ? SuccessSolidIcon : SuccessIcon}
            size="l"
            iconProps={{
              width: '30px',
              height: '30px',
              color: 'icon.accent',
            }}
            onClick={handleReadChange}
          />
          <NovaIconButton
            variant="primary"
            icon={isLiked ? FavoriteSolidIcon : FavoriteIcon}
            size="l"
            iconProps={{
              width: '30px',
              height: '30px',
              color: 'icon.accent',
            }}
            onClick={handleLikeChange}
          />
        </HStack>
        <VStack width="100%" alignItems="flex-start" gap="l" overflow="auto">
          <Text as="h4" textStyle={{ base: 'h2.medium', md: 'h1.semibold' }} color="text.primary">
            {title}
          </Text>

          <InformationBar
            readingTime={readingTime}
            relevantYears={relevantYears}
            ageGroups={ageGroups}
            isRead={isRead}
          />

          <ArticleTags tags={tags} />
        </VStack>
      </HStack>
    </Box>
  );
};
